import Component from "@glimmer/component";
import { concat } from "@ember/helper";
import { trustHTML } from "@ember/template";
import getURL from "discourse/lib/get-url";
import { i18n } from "discourse-i18n";
import { i18nForOwner } from "discourse/plugins/discourse-rewind/discourse/lib/rewind-i18n";

export default class ReadingTime extends Component {
  get readTimeString() {
    let totalMinutes = Math.floor(this.args.report.data.reading_time / 60);
    let leftOverMinutes = totalMinutes % 60;
    let totalHours = (totalMinutes - leftOverMinutes) / 60;

    if (leftOverMinutes >= 35) {
      totalHours += 1;
      return `${totalHours}h`;
    } else {
      return `${totalHours}h ${leftOverMinutes}m`;
    }
  }

  get bookComparisonText() {
    return i18nForOwner(
      "discourse_rewind.reports.reading_time.book_comparison",
      this.args.isOwnRewind,
      {
        readingTime: this.readTimeString,
        bookTitle: this.args.report.data.book,
        username: this.args.user?.username,
      }
    );
  }

  <template>
    <div class="rewind-report-page --reading-time">
      <h2 class="rewind-report-title">
        {{i18n "discourse_rewind.reports.reading_time.title"}}
      </h2>
      <div class="rewind-card">
        <p class="reading-time__text">
          {{trustHTML this.bookComparisonText}}
        </p>
        <div class="reading-time__book">
          <div class="book">
            <img
              alt=""
              src={{getURL
                (concat
                  "/plugins/discourse-rewind/images/books/"
                  @report.data.isbn
                  ".jpg"
                )
              }}
            />
          </div>
          {{#if @report.data.series}}
            <div class="book-series one"></div>
            <div class="book-series two"></div>
            <div class="book-series three"></div>
          {{/if}}
        </div>
      </div>
    </div>
  </template>
}
